import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

const CONTACTS = [
  {
    name: "Asistente",
    role: "Marcel — IA",
    avatar: "https://reinventemercadeo.com/wp-content/uploads/2026/03/marce-lopez-reinvente-team.png",
    wa: "https://wa.me/573043381885",
    msg: "Hola, quiero información sobre Reinvente Mercadeo 👋",
  },
];

export default function WhatsAppWidget() {
  const [open, setOpen] = useState(false);

  return (
    <div className="fixed bottom-5 right-5 z-50 flex flex-col items-end gap-2">
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: 12, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 12, scale: 0.95 }}
            transition={{ duration: 0.22, ease: [0.22, 1, 0.36, 1] }}
            className="w-[280px] rounded-2xl overflow-hidden shadow-[0_12px_48px_-8px_rgba(0,0,0,0.65)] ring-1 ring-white/10"
          >
            {/* Header */}
            <div className="bg-[#075E54] px-4 py-3 flex items-center justify-between">
              <div>
                <p className="text-white text-[13px] font-semibold leading-tight">
                  ¿Podemos ayudarte?
                </p>
                <p className="text-white/70 text-[11px] mt-0.5">
                  Responde en minutos
                </p>
              </div>
              <button
                onClick={() => setOpen(false)}
                className="h-7 w-7 grid place-items-center rounded-full bg-white/10 hover:bg-white/20 transition text-white"
                aria-label="Cerrar"
              >
                <X className="h-3.5 w-3.5" />
              </button>
            </div>

            {/* Contacts */}
            <div className="bg-[#ECE5DD] px-3 py-3 space-y-2">
              {CONTACTS.map((c) => (
                <a
                  key={c.wa}
                  href={`${c.wa}?text=${encodeURIComponent(c.msg)}`}
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center gap-3 bg-white rounded-xl px-3 py-2.5 shadow-sm hover:shadow-md transition group"
                >
                  <div className="relative shrink-0">
                    <img
                      src={c.avatar}
                      alt={c.name}
                      className="h-10 w-10 rounded-full object-cover object-top bg-gray-200"
                    />
                    <span className="absolute bottom-0 right-0 h-3 w-3 rounded-full bg-[#25D366] border-2 border-white" />
                  </div>
                  <div className="min-w-0 flex-1">
                    <p className="text-[13px] font-semibold text-gray-800 leading-tight">{c.name}</p>
                    <p className="text-[11px] text-gray-500 truncate">{c.role}</p>
                  </div>
                  {/* WhatsApp arrow */}
                  <svg className="h-4 w-4 text-[#25D366] shrink-0" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M9 18l6-6-6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
                  </svg>
                </a>
              ))}
            </div>

            {/* Footer */}
            <div className="bg-[#ECE5DD] px-3 pb-3">
              <p className="text-center text-[10px] text-gray-400">
                Powered by{" "}
                <span className="font-semibold text-gray-500">Reinvente Mercadeo</span>
              </p>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* FAB button */}
      <motion.button
        onClick={() => setOpen((v) => !v)}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        aria-label="Abrir chat WhatsApp"
        className="flex items-center gap-2 bg-[#25D366] hover:bg-[#20c15e] text-white rounded-full shadow-[0_6px_28px_-4px_rgba(37,211,102,0.6)] transition-colors"
        style={{ padding: open ? "10px 14px" : "10px 16px" }}
      >
        {/* WhatsApp SVG icon */}
        <svg className="h-5 w-5 shrink-0" viewBox="0 0 24 24" fill="currentColor">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
        </svg>
        {!open && (
          <span className="text-[13px] font-semibold whitespace-nowrap pr-0.5">
            ¿Puedo ayudarte?
          </span>
        )}
      </motion.button>
    </div>
  );
}
